<div class="modal fade" id="move-to-private-folder-confirmation-modal" role="dialog" aria-labelledby="move-to-private-folder-confirmation-modal" tabindex="-1" aria-hidden="true" [ngStyle]="{'display': moveToPrivateFolderConfirmation ? 'block' : 'none','opacity': 1, 'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)','-webkit-backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content h-90">
      <div class="modal-header">
        @if (!universalService?.isMobileDevice) {
          <button type="button" class="close btn-pos" data-dismiss="modal" (click)="closePopUp()">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
        }
        <h5 class="mb-0">Please Note</h5>
        @if (universalService?.isMobileDevice) {
          <span class="NeueFile_Cancel mt-1" (click)="closePopUp()"></span>
        }
      </div>

      <div class="modal-body border-bottom-0 pb-0">
        <div class="move-to-private-folder-confirmation mt-3">
          <ul>
            <li class="text">Sharing will be disabled for Files & Folders moved into the "Private Folder". Are you sure you want to continue? </li>
          </ul>
          <div class="option">
            <input type="checkbox" class="checkbox-button" id="checkbox-1" name="checkbox-button" checked>
            <label for="checkbox-1" class="checkbox-text"> Don't show this again</label>
          </div>
        </div>

      </div>
      <div class="modal-footer pt-0">
        <div class="btn-wrap">
          <button class="btn btn-cancel mt-1" id="cancel" data-dismiss="modal" (click)="closePopUp()">Cancel</button>
          <button class="btn btn-continue mr-md-0 mb-0 mt-2 mt-md-0 mb-md-0" id="continue" (click)="continueMove()">Continue</button>
        </div>
      </div>
    </div>
  </div>
</div>